import { getNewsAPI, addNewsAPI, getVideoLinksAPI, updateHomepageVideoAPI } from "./api"

// News Actions
export function getNews() {
    return new Promise((resolve, reject) => {
        getNewsAPI().then(res => resolve(res)).catch(err => reject(err))
    })
}

export function addNews(data) {
    return new Promise((resolve, reject) => {
        addNewsAPI(data).then(res => resolve(res)).catch(err => reject(err))
    })
}

// Video Links Actions
export function getVideoLinks(data) {
    return new Promise((resolve, reject) => {
        getVideoLinksAPI(data).then(res => resolve(res)).catch(err => reject(err))
    })
}

export function updateHomepageVideo(data) {
    return new Promise((resolve, reject) => {
        updateHomepageVideoAPI(data).then(res => resolve(res)).catch(err => reject(err))
    })
}
